<template>
  <div class="q-ml-md">
    <div class="q-mb-lg text-brand-1 text-weight-bold" style="font-size: 16px">
      Gestão de Biometria Facial do Usuário
    </div>
    <div>
      <ComponenteBiometriaFacial
        :idUsuario="route.params.id"
        :tipoMetodo="'cadastro'"
      />
    </div>
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";

import ComponenteBiometriaFacial from "../../../components/biometriaFacial/ComponenteBiometriaFacial";

const route = useRoute();
</script>
